import { RiArrowRightSLine } from '@remixicon/react';
import type { AccessibleTenant, MeResponse } from '@atnt/shared';
import { cn } from '@/shared/lib/cn';

/** Hairline on the sidebar's right edge, drawn inside like Figma's INSIDE stroke (keeps the 224 content width). */
export const SidebarEdge = () => <span aria-hidden className="pointer-events-none absolute inset-y-0 right-0 w-px bg-line" />;

/** arrow-right-s-line rotated 90° = arrow-down-s-line (the glyphs are exact rotations of each other). */
export function Chevron({ open, className }: { open: boolean; className?: string }) {
  return (
    <RiArrowRightSLine
      aria-hidden
      className={cn('size-20 shrink-0 text-icon transition-transform duration-150 ease-standard', open && 'rotate-90', className)}
    />
  );
}

export const rowFocus = 'outline-none focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-accent-2';

/** Tenants grouped by organization (headers are only shown when there are several). */
export function tenantsByOrganization(me: MeResponse) {
  const byOrg = new Map<string, AccessibleTenant[]>();
  for (const t of me.tenants) byOrg.set(t.organizationId, [...(byOrg.get(t.organizationId) ?? []), t]);
  return [...byOrg.entries()].map(([id, tenants]) => ({
    id,
    name: me.organizations.find((o) => o.id === id)?.name ?? '',
    tenants,
  }));
}

/** Is `rest` (path after `/t/:slug/`) the page of `segment` or one of its sub-pages? */
export const isUnder = (rest: string | null, segment: string) => rest !== null && (rest === segment || rest.startsWith(segment + '/'));
